export default {
  getOptionsListText(state, getters) {
    const options = state.optionsList;

    if (options) {
      return options.filter(item => item.field_type === 'T');
    }

    return [];
  },

  getIsDisabledAddToCart(state) {
    return state.isDisabledAddToCart;
  },

  getOptionsList(state, getters) {
    const options = state.optionsList;

    if (options) {
      const electric_kit = options.find(el => getters.isOptionElectrikKit(el.use_type));

      return options.filter(item => {
        let result = true;

        result = !getters.isOptionDormer(item.code_1c);

        if (electric_kit) {
          if (getters.isOptionElectrikDrive(item.use_type)) {
            return false;
          } else if (getters.isOptionElectricDriveType(item.use_type)) {
            return false;
          }
        }

        return result;
      });
    }

    return [];
  },

  getOptionType(state, getters) {
    const options = state.optionsList;
    let result = null;

    if (options) {
      const item = options.find(el => getters.isOptionDormer(el.code_1c));
      result = item ? item : null;
    }

    return result;
  },

  isOptionManagement: () => code_1c => {
    return code_1c === 'Управление';
  },

  isOptionDormer: () => code_1c => {
    return code_1c === 'ТипМансардногоОкна';
  },

  isOptionDlupr: () => code_1c => {
    return code_1c === 'Длупр';
  },

  isOptionElectrikDrive: () => type => {
    return type === 'electric_drive';
  },

  isOptionElectricDriveType: () => type => {
    return type === 'electric_drive_type';
  },

  isOptionElectrikKit: () => type => {
    return type === 'electric_kit';
  },

  isOptionTube: () => type => {
    return type === 'tube_diameter';
  },

  isSlopingCornice: () => code_1c => {
    return code_1c === 'РеквБулево_1';
  },

  isTiltSide: () => code_1c => {
    return code_1c === 'СторонаНаклона';
  },

  getOptionTiltSide(state, getters) {
    const options = state.optionsList || [];
    const find = options?.find(item => getters.isTiltSide(item.code_1c));

    return find;
  },

  getOptionSlopingCornice(state, getters) {
    const options = state.optionsList || [];
    const find = options?.find(item => getters.isSlopingCornice(item.code_1c));

    return find;
  },

  getOptionManagement(state, getters) {
    const options = state.optionsList || [];
    const find = options?.find(item => getters.isOptionManagement(item.code_1c));

    return find;
  },

  getDluprDisabled(state, getters) {
    const electrik_kit = getters.getOptionElectrikKit;

    if (electrik_kit) {
      const { option_default, options_values } = electrik_kit;
      const option = options_values.find(el => el.id === option_default);

      if (option && option.value) {
        return true;
      }
    }

    return false;
  },

  getOptionDlupr(state, getters) {
    const options = state.optionsList;
    let result = null;

    if (options) {
      const item = options.find(el => getters.isOptionDlupr(el.code_1c));
      result = item ? item : null;
    }

    return result;
  },

  getOptionElectrikDriveType(state, getters) {
    const options = state.optionsList || [];
    const find = options?.find(item => getters.isOptionElectricDriveType(item.use_type));

    return find;
  },

  getOptionElectrikDrive(state, getters) {
    const options = state.optionsList;
    let result = null;

    if (options) {
      const item = options.find(el => getters.isOptionElectrikDrive(el.use_type));
      result = item ? item : null;
    }

    return result;
  },

  getOptionElectrikKit(state, getters) {
    const options = state.optionsList;
    let result = null;

    if (options) {
      const item = options.find(el => getters.isOptionElectrikKit(el.use_type));
      result = item ? item : null;
    }

    return result;
  },

  getOptionTube(state, getters) {
    const options = state.optionsList;
    let result = null;

    if (options) {
      const item = options.find(el => getters.isOptionTube(el.use_type));
      result = item ? item : null;
    }

    return result;
  },

  getOptionTypeDefaultValue(state, getters) {
    const option = getters.getOptionType;
    let result = null;

    if (option) {
      for (let key in option.options_values) {
        const item = option.options_values[key];

        for (let subKey in item) {
          const subItem = item[subKey];

          for (let i = 0; i < subItem.length; i++) {
            if (subItem[i].id === option.option_default) {
              result = {
                item: key,
                sub: subKey,
                elem: subItem[i],
              };
              break;
            }
          }
        }
      }
    }

    return result;
  },

  getOptionNotStandart(state, getters) {
    const options = getters.getOptionsList;
    const option = options.find(el => el.code_1c === 'Нестандарт');

    if (option) {
      const value = option.options_values.find(el => el.id === option.option_default);

      if (value?.name === 'Да') {
        return true;
      }
    }

    return false;
  },
};
